<script>
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxDelete } from '@utils/message-box'
import cloneDeep from 'lodash/cloneDeep'
import { authComputed } from '@state/helpers'
const conditionList = (list) => {
  return list.filter(({condition})=>{
    if (condition) return condition()
    return true
  })
}
export default {
  page: {
    title: '編輯客戶資訊',
    meta: [{ name: 'add-member', content: 'Edit Member' }],
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeTab: '0',
      submitData: cloneDeep(this.defaultValue),
      tryingToSave: false,
      editDetailEnabled: false,
      currentType: '',
    }
  },
  computed: {
    ...authComputed,
    tabList() {
      return Object.freeze(conditionList([
        {
          title: '基本資料',
          alias: 'member',
          component: () => import('./DetailEditMemberInfo'),
        },
        {
          title: '會籍資料',
          alias: 'view-memberlevel',
          component: () => import('./DetailEditMemberLevel'),
          condition: () => {
            return true
          }
        },
        {
          title: '發票資訊',
          alias: 'tax',
          component: () => import('./DetailEditMemberTax'),
          condition: () => {
            return this.defaultValue.storeInvoiceSetting === 1
          }
        },
        {
          title: '客戶備註',
          alias: 'note',
          component: () => import('./DetailEditMemberNotice'),
        },
      ]))
    }
  },
  watch: {
    defaultValue(value) {
      this.$nextTick(()=>{
        this.submitData = cloneDeep(this.defaultValue)
      })
      // console.log(value)
    },
  },
  created() {
    // console.log(this.$route.params.pagination)
  },
  methods: {
    async onClickSave(type) {
      await this.validate()
      this.tryingToSave = true 
      await this.$store.dispatch('member/store', this.submitData)
      .then(() => {
        messageStore('edit')
      })
      .finally(()=> {
        this.tryingToSave = false
      })
    },
    async validate(step) {
      const currentTab = `step${this.activeTab}`
      // console.log(this.$refs[currentTab].$refs.form)
      await this.$refs[currentTab].$refs.form.validate()
    },
    onUpdate() {
      this.$emit('update')
    },
    cancel() {
      this.editDetailEnabled = false
      this.submitData = cloneDeep(this.defaultValue)
      this.cancelEdit()
    },
    isOpen(item) {
      return !this.currentUserRoutes.includes(item)
    },
    enableEditDetail(val) {
      this.editDetailEnabled = val.isEditEnabled
    },
    cancelEdit() {
      const currentTab = `step${this.activeTab}`
      this.$refs[currentTab].editDetailEnabled = false
      this.editDetailEnabled = false
    },
    cancelTagEdit() {
      this.submitData.tags = [...this.defaultValue.tags]
      this.editTagEnabled = false
    },
    cancelEditDetail() {
      const { fullName, gender, email } = this.defaultValue
      this.submitData = {
        ...this.submitData,
        fullName,
        gender,
        email,

      }
      this.editDetailEnabled = false
    },
    cancelEditInvoice() {
      const { taxType, taxId, CarrierType, CarrierNum, LoveCode } = this.defaultValue
      this.submitData = {
        ...this.submitData,
        taxType,
        taxId,
        CarrierType,
        CarrierNum,
        LoveCode,
      }
      this.editInvoiceEnabled = false
    },
    async saveEdit(type = '') {
      // if (this.$refs.form) await this.$refs.form.validate()
      if(type === 'note') {
        this.saveComment()
      } else {     
        if(!!type && type !== 'note') await this.validate()
        this.tryingToSave = true 
        // if (this.$refs['form-invoice']) await this.$refs['form-invoice'].validate()
        if (!this.defaultValue.shippingInfo && !this.defaultValue.billingInfo) {
          delete this.submitData.billingInfo
          delete this.submitData.shippingInfo
        }
        await this.$store.dispatch('member/store', {
          ...this.submitData,
          merchantNote: this.submitData.merchantNote,
          CarrierNum: this.submitData.CarrierType === '2' ? this.defaultValue.phoneNumber : this.submitData.CarrierNum,
        })
        // this.submitData.merchantNote = type === 'note' ? this.editedNote : this.submitData.merchantNote

        await this.tryToFetchMember()
        // this.editedNote = this.submitData.merchantNote
        this.cancelEdit()
        // this.cancelEditDetail()
        // this.cancelTagEdit()
        // this.cancelEditInvoice()
        this.tryingToSave = false 
      }
    },
    async saveComment() {
      const commentComponentStep = this.defaultValue.storeInvoiceSetting === 1 ? 'step3' : 'step2'
      await this.$refs[commentComponentStep].$refs.form.validate()
      this.tryingToSave = true 
      await this.$store.dispatch('comment/store', {
        memberId: this.defaultValue.id,
        content: this.$refs[commentComponentStep].$refs.form.model.content,
        type: 'member_private'
      }).finally(()=> {
        this.tryToFetchMember()
        this.cancelEdit()
        this.tryingToSave = false
      })
    },
    async tryToFetchMember() {
      this.$emit('update')
    },
/*     enableEditAddress(mode) {
      this.addressMode = mode
      this.visibleDialog = true
    }, */
/*     onSelectCity() {
      // console.log(111)
      if (this.addressMode === 'billing') {
        this.submitData[`${this.addressMode}Info`] = {
          ...this.submitData[`${this.addressMode}Info`],
          district: '',
          postcode: '',
        }
      }
      if (this.addressMode === 'shipping') {
        this.submitData[`${this.addressMode}Info`][0].district = ''
        this.submitData[`${this.addressMode}Info`][0].postcode = ''
      }
    }, */
/*     onSelectDistrict() {
      if (this.addressMode === 'shipping') {
        const { city, district } = this.submitData[`${this.addressMode}Info`][0]
        this.submitData[`${this.addressMode}Info`][0].postcode = findDistrictZip(city, district)
      }
      if (this.addressMode === 'billing') {
        const { city, district } = this.submitData[`${this.addressMode}Info`]
        this.submitData[`${this.addressMode}Info`].postcode = findDistrictZip(city, district)
      }
    }, */
/*     async onSaveAddress() {
      try {
        await this.$refs.addressForm.validate()
        this.tryingSave = true
        await this.saveEdit()
        await this.tryToFetchMember()
        this.visibleDialog = false
      } catch {
      } finally {
        this.tryingSave = false
      }
    }, */
/*     handleClose() {
      this.submitData = cloneDeep(this.defaultValue)
      this.getDefaultAddress()
      this.visibleDialog = false
    }, */
  },
}
</script>
<template>
  <div :class="$style.page">
    <el-tabs v-model="activeTab" type="border-card" stretch class="isStyleBase" :before-leave="cancel">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`">
        <!-- <component 
          :is="tab.component" 
          :ref="`step${index + 1}`" 
          :default-value.sync="submitData" 
          @update="onUpdate"
        /> -->
      </el-tab-pane>
    </el-tabs>
    <component
      :is="tabList[activeTab].component" 
      :ref="`step${activeTab}`"
      v-model="submitData"
      v-loading="tryingToSave"
      :class="$style.pageContent"
      @update="onUpdate"
      @save="saveEdit"
      @isEditDeatilEnabled="enableEditDetail"
    ></component>
    <div
      v-if="editDetailEnabled" 
      :class="$style.footer"
    >
      <el-button class="is-round" :loading="tryingToSave" @click="cancel">取消編輯</el-button>
      <el-button class="is-round" type="primary" :loading="tryingToSave" @click="saveEdit(tabList[activeTab].alias)">儲存編輯</el-button>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
